import { render, staticRenderFns } from "./AviationQuestionnaireCN.vue?vue&type=template&id=2900489a"
import script from "./AviationQuestionnaireCN.vue?vue&type=script&lang=js"
export * from "./AviationQuestionnaireCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports